import React from 'react';
import Container from 'react-bootstrap/esm/Container';

import { AreaTable } from '../Component/Area/AreaTable';

export const AreasPage = () => {
  return (
    <Container style={{ marginTop: '50px' }}>
      <AreaTable />
    </Container>
  );
};
